import React from 'react';
import { Typography } from '@mui/material';
import { formatNumberToCurrency } from 'utils/formatters';
import { CurrencyType } from 'enum/currency';

interface Props {
  amount?: number;
  isColor?: boolean;
  variant: 'h4' | 'subtitle1' | 'subtitle2' | 'h5';
  symbol?: '₹' | '+' | '$';
  isShortForm?: boolean;
  isPercentage?: boolean;
  currency?: CurrencyType;
}

const Amount: React.FC<Props> = ({
  amount = 0,
  variant,
  isColor = false,
  symbol,
  isShortForm = false,
  isPercentage = false,
  currency = CurrencyType.INR
}) => {
  let textColor = 'inherit';
  if (isColor) {
    textColor = amount === 0 ? 'inherit' : amount > 0 ? 'green' : 'error';
  }

  return (
    <Typography variant={variant} color={textColor}>
      {amount > 0 && symbol}
      {formatNumberToCurrency(amount, false, currency, isShortForm)}
      {isPercentage && '%'}
    </Typography>
  );
};

export default Amount;
